function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React from 'react';
import cn from 'classnames';
import T from 'prop-types';
var Chip = function(param) {
    var label = param.label, className = param.className, active = param.active, onSelect = param.onSelect;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn('Chip', _define_property({
            active: active
        }, className, className)),
        onClick: onSelect
    }, label);
};
Chip.propTypes = {
    label: T.string.isRequired,
    className: T.string,
    active: T.bool,
    onSelect: T.func
};
export { Chip };
